// 📁 src/Common/RomanBanner.jsx

import React, { useEffect, useState } from 'react';
import '../styles/romanBanner.css';

export default function RomanBanner() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible((prev) => !prev);
    }, 3000); // ⏱ 3s toggle
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-40 roman-banner transition-opacity duration-500 ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      Save time, save money
    </div>
  );
}
